import BannerLink from './BannerLink';

export default BannerLink;
